import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
    getAssignmentList,
    getAssignments,
    GetAssignmentsParams,
    GetAssignmentListParams,
} from '../clients/gateway.api';

export const assignments = createQueryKeys('assignments', {
    list: (params: GetAssignmentListParams) => ({
        queryKey: [params],
        queryFn: () => getAssignmentList(params),
    }),
    comboBoxOptions: (params: GetAssignmentListParams) => ({
        queryKey: [params],
    }),
    pagination: (params: GetAssignmentsParams) => ({
        queryKey: [params],
        queryFn: () => getAssignments(params),
    }),
});
